import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHDepartamentoIns = async (credentials, data) => {
    const body = {
        service: "RNHDepartamentoIns",
        params: {
            rnhDepartamentoCod: data?.cod || null,
            rnhDepartamentoNombre: data?.name || null,
            rnhDepartamentoDescripcion: data?.desc || null,
            // Los dos permisos de la reparticion. "Y"/"N", como el resto de las
            // banderas del modulo. Con `|| null` porque las dos son strings truthy: si
            // el modal los manda viaja el valor, y si todavia no los manda viaja null,
            // que para estos servicios es "no informado".
            rnhDepartamentoAdmiteRotativos: data?.admiteRotativos || null,
            rnhDepartamentoAdmiteGuardias: data?.admiteGuardias || null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
